/**
 * Determine if a location is a Plentiful provider
 *
 * This function handles inconsistencies created by disperate views of Pantry/Location data (the exact reason for this
 * is unclear at the moment and does need to be fixed).
 *
 * @param {object} location - Pantry/Location object
 * @returns {boolean} true if it's a Plentiful provider, false otherwise
 */
export function isPlentifulProvider(location) {
  if (!location) return false;

  // Check explicit property first
  if (location.has_plentiful_pantry !== undefined) {
    return location.has_plentiful_pantry;
  }

  // Fallback to pantry_id-based logic
  return location.pantry_id && location.pantry_id > 0;
}

export default {
  isPlentifulProvider,
};
